import { useState } from "react";
import { faqs } from "@/mocks/gossip";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-secondary-700">
              <i className="ri-question-answer-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              常见问答
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">新吃瓜群众最常问的几件事</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于论坛、吃瓜群、内容真实性以及新手流程的常见疑问，都整理在右侧。点击问题即可展开查看答案，键盘也能操作。
            </p>
          </div>

          <div className="lg:col-span-2 space-y-3">
            {faqs.map((item, index) => {
              const isOpen = open === index;
              return (
                <div key={index} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left cursor-pointer hover:bg-primary-50/60 transition-colors md:px-5"
                  >
                    <span className="text-sm font-medium text-foreground-950 md:text-base">{item.q}</span>
                    <span className={"flex items-center justify-center w-6 h-6 shrink-0 rounded-full transition-colors " + (isOpen ? "bg-primary-500 text-background-50 dark:text-foreground-950" : "bg-background-200 text-foreground-600")}>
                      <i className={isOpen ? "ri-subtract-line text-sm" : "ri-add-line text-sm"} aria-hidden="true"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="border-t border-background-200 px-4 py-4 md:px-5">
                      <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}